<template>
    <component
        :is="entry.component"
        class="tl-prime-dialog"
        v-bind="entry.bindings"
        v-on="entry.listeners || {}"
    />
</template>

<script lang="ts" setup>
import { watch } from 'vue'
import { closeModalById, provideModalEntryId, type ModalEntry } from '@/composables/modal'

const props = defineProps<{ entry: ModalEntry }>()

provideModalEntryId(props.entry.id)

watch(() => props.entry.opened, opened => {
    if (!opened) closeModalById(props.entry.id)
})
</script>
